/**
 * Виртуальные файлы запуска в совместной комнате.
 * Короткие файлы синхронизируются через Yjs. Большой файл условия
 * (таблица ЕГЭ №9 и похожие) каждый браузер берёт сам с сервера:
 * целиком в комнате он раздувает документ на мегабайты.
 */

/** Один файл длиннее этого в Yjs не пишем. */
export const YJS_SYNC_FILE_MAX_CHARS = 64 * 1024;

export function isOversizedRunnerFile(content) {
  return typeof content === 'string' && content.length > YJS_SYNC_FILE_MAX_CHARS;
}

/** Только файлы, которые можно положить в filesJson. */
export function filesForYjsSync(files) {
  const out = {};
  if (!files || typeof files !== 'object') return out;
  for (const [name, content] of Object.entries(files)) {
    if (typeof content !== 'string' || isOversizedRunnerFile(content)) continue;
    out[name] = content;
  }
  return out;
}

export function runnerFilesJsonForSync(files) {
  return JSON.stringify(filesForYjsSync(files));
}

export function runnerFilesJsonHasOversized(parsed) {
  if (!parsed || typeof parsed !== 'object') return false;
  return Object.values(parsed).some((value) => isOversizedRunnerFile(value));
}

/**
 * Слить filesJson комнаты с локальными файлами.
 * Мелкие ключи из комнаты — источник правды (правки и удаления).
 * Крупный файл остаётся локальным: из комнаты берём его только если своего ещё нет
 * (старая комната, где таблица уже лежит в документе).
 */
export function mergeRemoteRunnerFiles(localFiles, remoteFiles) {
  const local = localFiles && typeof localFiles === 'object' ? localFiles : {};
  const remote = remoteFiles && typeof remoteFiles === 'object' ? remoteFiles : {};
  const merged = {};

  for (const [name, content] of Object.entries(remote)) {
    if (typeof content !== 'string' || isOversizedRunnerFile(content)) continue;
    merged[name] = content;
  }

  for (const [name, content] of Object.entries(remote)) {
    if (!isOversizedRunnerFile(content)) continue;
    const own = local[name];
    merged[name] = typeof own === 'string' ? own : content;
  }

  for (const [name, content] of Object.entries(local)) {
    if (!isOversizedRunnerFile(content) || name in merged) continue;
    merged[name] = content;
  }

  return merged;
}
